<div [formGroup]="filterGroup">
  <div class="header">
    <span>Filter by</span>
    <inline-svg
      src="small_close.svg"
      (click)="closeMenu.emit()"
      matTooltip="Close"
      class="close-icon"
      color="#A5B5BD"
      hoverColor="#7F8F98"
    ></inline-svg>
  </div>
  <div class="horizontal-separator"></div>

  <div formArrayName="orGroups">
    @for (orGroup of orGroupsFormGroups; track $index; let groupIndex = $index)
    {
    <div class="filter-block-row">
      <div class="filter-block" [formGroup]="orGroup">
        <div formArrayName="filters">
          @for (filterRow of getFiltersFormGroups(groupIndex); track $index; let
          filterIndex = $index) {
          <div class="filter-row" [formGroup]="filterRow">
            <mat-form-field appearance="outline">
              <mat-select formControlName="field" panelClass="filter-select">
                <mat-option value="">Select Field</mat-option>
                @for (field of availableFields; track field.name) {
                <mat-option [value]="field.name">
                  {{ field.name }}
                </mat-option>
                }
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-select formControlName="operator" panelClass="filter-select">
                @for (operator of
                getOperatorsForField(getFieldType(filterRow.get('field')?.value
                || '')); track operator) {
                <mat-option [value]="operator">
                  {{ filterOperatorShortLabels[operator] }}
                </mat-option>
                }
              </mat-select>
            </mat-form-field>

            @if (operatorRequiresValue(filterRow.get('operator')?.value)) {
            <mat-form-field appearance="outline">
              @if (getFieldType(filterRow.get('field')?.value || '') ===
              'boolean') {
              <mat-select formControlName="value" panelClass="filter-select">
                <mat-option [value]="true">True</mat-option>
                <mat-option [value]="false">False</mat-option>
              </mat-select>
              } @else { @if (filterRow.get('operator')?.value === 'in' ||
              filterRow.get('operator')?.value === 'not_in') {
              <input
                matInput
                formControlName="value"
                placeholder="Value1|Value2|Value3"
              />
              } @else {
              <input matInput formControlName="value" placeholder="Value" />
              } }
            </mat-form-field>
            } @if (getFiltersArray(groupIndex).length > 1) {
            <div
              class="icon icon-clear"
              (click)="removeFilter(groupIndex, filterIndex)"
              matTooltip="Remove Filter"
            ></div>
            }
          </div>
          }
        </div>

        <div class="filter-block-buttons">
          <button
            matButton
            class="add-filter-btn"
            (click)="addFilter(groupIndex)"
          >
            <div class="icon icon-plus"></div>
            <span>Add Filter</span>
          </button>

          <button
            matButton
            class="clear-group-btn"
            (click)="clearGroup(groupIndex)"
          >
            Clear All
          </button>
        </div>
      </div>
      @if (orGroupsArray.length > 1) {
      <div
        class="remove-block-btn"
        (click)="removeOrGroup(groupIndex)"
        matTooltip="Remove Filter Block"
      >
        <div class="icon icon-trash"></div>
      </div>
      }
    </div>

    @if (groupIndex < orGroupsArray.length - 1) {
    <div class="or-separator">
      <span class="or-text">or</span>
    </div>
    } }
  </div>

  <button
    mat-raised-button
    class="frmg-secondary-button add-or-query-btn"
    (click)="addOrGroup()"
  >
    <div class="icon icon-plus"></div>
    <span>Add Or Query</span>
  </button>

  <div class="action_container">
    <button mat-raised-button class="frmg-secondary-button" (click)="clear()">
      Clear All
    </button>
    <button
      mat-raised-button
      class="frmg-primary-button"
      (click)="apply()"
      [disabled]="filterGroup.invalid"
    >
      Apply Filter
    </button>
  </div>
</div>
